export default __webpack_public_path__ + "static/media/newsflash.2753ec16.svg";